import React from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import { SimTypography } from 'components/SimTypography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

const FeedingOccuTherapySummary = () => {
	const theme = useTheme();

	return (
		<Box>
			<Box
				height={{ sm: '70vh', lg: '50vh' }}
				sx={{
					backgroundImage: `linear-gradient(${alpha(theme.palette.divider.dark, 1)} 0%, ${alpha(
						theme.palette.background.default,
						0
					)} 100%)`
				}}>
				<Box
					display='flex'
					justifyContent='center'
					alignItems={'center'}
					alignContent='center'
					height={1}
					width={1}>
					<Box
						padding={2}
						width={1}
						sx={{
							bgcolor: 'rgba(0, 0, 0, 0)'
						}}
						display='flex'
						justifyContent='center'
						alignContent={'center'}
						alignItems={'center'}>
						<Container>
							<Box>
								<SimTypography
									variant='h3'
									align={'left'}
									paddingCenter='2vw'
									data-aos={'fade-up'}
									gutterBottom
									sx={{
										fontWeight: 700,
										marginTop: theme.spacing(1)
									}}>
									Feeding & Occupational Therapy
								</SimTypography>

								<SimTypography
									color={theme.palette.primary.main}
									variant='h6'
									align={'left'}
									data-aos={'fade-up'}>
									Early intervention is{' '}
									<Box component='span' color={theme.palette.secondary.mainOrange}>
										CRITICAL
									</Box>
								</SimTypography>

								<Box marginTop={4}>
									<SimTypography
										color={theme.palette.text.main}
										variant='h6'
										align={'left'}
										data-aos={'fade-up'}>
										Feeding Therapy teaches children and parents how to not only eat and eat better
										but also eating is an enjoyable experience for kids and parents.
									</SimTypography>
									<SimTypography
										color={theme.palette.text.main}
										variant='h6'
										align={'left'}
										data-aos={'fade-up'}>
										Occupational Therapy focuses on (re)gaining independence by helping children
										develop physical, sensory, or cognitive skills.
									</SimTypography>
								</Box>
							</Box>
						</Container>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export { FeedingOccuTherapySummary };
